import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const styleSheet = document.createElement('style');
styleSheet.textContent = `* { box-sizing: border-box; }`;
document.head.appendChild(styleSheet);

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
